<template>    
    <!-- <div>
        <PhotoAlbum :photos="filesArray" layout="rows" :default-container-width="1200" /> 
         <div class="team-list">
            <div class="team-item" v-for="file in filesArray" :key="file.key">
                <el-image
                    :src="file.src"
                    fit="cover"
                    :alt="file.alt"
                    style="width: %; height: 100%">
                <p>{{ file.title }}100</p>
            </div>
         </div>
    </div> -->
    <!--div class="demo-image__lazy">
        <el-image v-for="file in filesArray" :key="file.key" :src="file.src" lazy />
    </div-->

    <Galleria class="team-gallery__gallery" v-if="filesArray?.length > 0" :value="filesArray" :responsiveOptions="responsiveOptions" :numVisible="6" containerStyle="max-width: 1000px">
        <template #item="slotProps">
            <img :src="getImageSrc(slotProps.item)" :alt="slotProps.item.alt" style="width: 100%" />
        </template>
        <template #thumbnail="slotProps">
            <img :src="slotProps.item.thumbnailImageSrc" :alt="slotProps.item.alt" />
        </template>
    </Galleria>
    <div class="team-gallery__empty-text" v-if="filesArray.length === 0">
                There are no images in the gallery
    </div>
</template>

<script>

    //import { PhotoAlbum } from 'vue-photo-album'
    import Galleria from 'primevue/galleria';
    import { showMessage } from '@/utils/messages.js';
    import { getTeamGalleryFiles, getGalleryImage } from '@/api/team.js';

    export default {
        name: 'TeamGallery',
        components: {
            //PhotoAlbum,
            Galleria,
        },
        props: {
            teamId: {
                type: Number,
                required: true,
            },
            isAdmin: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                filesArray: [],
                responsiveOptions: [
                    {
                        breakpoint: '1300px',
                        numVisible: 4
                    },
                    {
                        breakpoint: '575px',
                        numVisible: 1
                    }
                ],
            };
        },

        methods: {
            async fetchGalleryFilesArray() {

                const { teamId } = this;
                const { data, success } = await getTeamGalleryFiles({ teamId });
                
                if( success ) {

                    for(let i=0; i<data.items.length; i++) {
                        URL.revokeObjectURL( this.filesArray.thumbnailImageSrc );
                        URL.revokeObjectURL( this.filesArray.imageSrc );
                    }
                    this.filesArray = [];
                    for(let i = 0; i < data.items.length; i++) {
                        this.filesArray.push(
                            {
                                thumbnailImageSrc: URL.createObjectURL( await getGalleryImage({url: data.items[i].url, thumbnail: true}) ), 
                                itemImageSrc: null, //URL.createObjectURL( await getGalleryImage({url: data.items[i].url, thumbnail: false})),
                                title: data.items[i].name,
                                alt: data.items[i].name,
                                key: data.items[i].id,
                                url: data.items[i].url,
                            });
                    };                    
                } else {
                    showMessage({ type: 'error', message: 'Failed to images' });
                }
            },

            getImageSrc(item) {

                //console.log(item);

                if (!item.itemImageSrc) {
                    getGalleryImage({url: item.url, thumbnail: false}).then( result => {
                        item.itemImageSrc = URL.createObjectURL( result );
                    });
                }
                return item.itemImageSrc;
            },

            async fetchGalleryMainImages() {
                for(let i = 0; i < this.filesArray.length; i++) {
                    if( !this.filesArray[i].itemImageSrc ) {
                        this.filesArray[i].itemImageSrc = URL.createObjectURL( await getGalleryImage({url: this.filesArray[i].url, thumbnail: false}) );
                    }
                }
            },
        },

        async mounted() {
            await this.fetchGalleryFilesArray();
            await this.fetchGalleryMainImages();
        },
    }

</script>


<style scoped>
.team-gallery {
    padding: 20px;
}

&__empty-text {}

&__gallery {
    max-width: 1000px;
    margin: 0 auto;
    align-content: center;
    align-items: center;
    align-self: center ;
    justify-content: center;
    justify-items: center;
    justify-self: center;
}

.team-list {
    display: flex;
    flex-wrap: wrap;
}

.team-item {
    border: 1px solid #ccc;
    padding: 10px;
    margin: 10px;
    width: 200px;
}

.gallery-image__lazy {
  height: 400px;
  overflow-y: auto;
}
.gallery-image__lazy .el-image {
  display: block;
  min-height: 200px;
  margin-bottom: 10px;
}
.gallery-image__lazy .el-image:last-child {
  margin-bottom: 0;
}
</style>